import { createSchema, createValidation } from '~/utils/validator';

export const reportValidationSchema = (t) =>
  createSchema({
    message: createValidation()
      .required(t('error.fieldRequired'))
      .minLength(t('error.minCharCountErr', { count: 3 }), 3),
    request_type: createValidation().exist(t('error.fieldRequired')),
  });

export const reportWithoutMessageValidationSchema = (t) =>
  createSchema({
    request_type: createValidation().exist(t('error.fieldRequired')),
  });
